import * as React from 'react'
import { FetchAppContextQuery } from '../../../common/src/types.gen'

export class AppCtx {
  constructor(public appContext: FetchAppContextQuery | undefined) {}
}

export const AppContext = React.createContext<AppCtx>(new AppCtx(undefined))
